
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { ClientRegistrationController } from "@/app/ui/controllers/ClientRegistrationController";
import { ClientDetailUpdateItem } from '@/domain/entities/ClientManagement';
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";

class Props {
  isManagement = prop<boolean>({
    default: false,
    required: false,
    type: Boolean
  });
}
@Options({
  components: {
    Title
  }
})
class DetailBankSettlementInformation extends Vue.with(Props) {
  get detailData() {
    if (this.isManagement) {
      return ClientManagementController.detailClientManagement;
    }
    return ClientRegistrationController.clientRegistrationDetail;
  }

  get bankDetail() {
    return this.detailData.bankSettlement
  }

  get newestUpdated() {
    if (this.detailData.detailUpdate.newestUpdatedBankSettlement.length) {
      return this.detailData.detailUpdate.newestUpdatedBankSettlement[0]
    }

    return new ClientDetailUpdateItem({
      updatedByName: this.detailData.clientCreatedBy,
      updatedAt: formatDate(this.detailData.clientCreatedAt)
    })
  }

  get isShowBankLogo() {
    return ["bni", "bca", "bri"].includes(this.bankDetail.bankName);
  }
}
export default DetailBankSettlementInformation;
